// @flow
export { default } from './reviews';



// WEBPACK FOOTER //
// ./src/pages/reviews/index.js